<div class="wrapper">
    <a 
		role="button"
		class="nsw-link nsw-link--icon icon-wrapper" 
		(click)="toggleFavourite($event)"
        href="javascript:void(0)"
		[tabindex]="0"
        style="cursor:pointer;">        
		<img
            class="tooltip-icon"
            [src]="'assets/images/FavouriteIcons/' + (isFavourite ? 'favourites-selected.svg' : unselectedIcon)"  
            [alt]="siteName ?? 'favourite site'">
		<span *ngIf="showLabel" class="label" 
            [attr.aria-label]="isFavourite ? 'Remove from favourites' : 'Add to favourites'">
            {{isFavourite ? "Remove from favourites" : "Add to favourites"}}
        </span>				
	</a>
</div>

